import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetSharingState from './datasetSharing';
import updateDatasetSettingsState from './datasetSettings';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasetSharingState,
  ...updateDatasetSettingsState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
